<template >
   <scroll-up :scroll-duration="2100" :scroll-y="650" class="scroll-up-uniq" @click.native="focusTopOfPage"></scroll-up>
</template>

<script>
import ScrollUp from 'vue-scroll-up';
import 'vue-scroll-up/dist/style.css';
export default {
    
    name: 'ScrollPages',    
    data(){
        return{   
          LOCAL_HOST:this.$store.state.LOCAL_HOST,               
        };        
    },
    components:{
        ScrollUp  
    },
    methods:{
      focusTopOfPage() {
          document.getElementById('skip-content').focus();
      }
    } 
};
</script>
<style scoped>
::v-deep .vue-scroll-up {  
  background-color:#00224a;  
  right: 10px;  
  background-image: url('/ThemeCosmic/images/up-arrow.png');
  background-position: center; 
  background-repeat: no-repeat;
  background-size: 63px 63px;
  bottom: 25px;
}
::v-deep .vue-scroll-up:hover { 
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 75%), 0 2px 10px 0 rgb(0 0 0 / 12%);
}
::v-deep .vue-scroll-up::after {
  content: '';
  display: block;
  width: 10px;
  height: 25px;
  border: none;
  border-radius: 10px;
  margin: 0 auto;
}
::v-deep .vue-scroll-up::before {  
  /*  content: "\2191"; */
  content: "scroll to top";
  font-size: 0px;
  position: absolute;
  width: 0;
  height: 0;
  border: none;
  left: 25%;
  top: -18px; 
  animation:none;
}
</style>